import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import Box from 'components/shared/Box'

export const Wrapper = styled(Box)`
    text-align: center;
    border: 2px solid ${({ theme }) => theme.colors.grayscale_300};
    border-radius: 8px;

    @media ${respondAbove.xl} {
        text-align: left;
    }

    img {
        min-width: 96px;
        height: 96px;

        @media ${respondAbove.xl} {
            min-width: 120px;
            height: 120px;
        }
    }
`
